// Copyright (c) 2022 by Move Closer
import { AbstractTypeDriver } from './abstract';
import { RelatedType } from '../contracts';
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class SnippetDriver extends AbstractTypeDriver {
    constructor() {
        super(...arguments);
        this.adapterMap = {};
        this.dependencies = [];
        this.typeKey = RelatedType.Snippet;
    }
}
